import { typeMap as errorTypeMap } from './type-map';
import { GeneralError } from './base';

export class MolfileParsingError extends GeneralError {
  constructor(payload) {
    super(errorTypeMap.parsing.molfile.general, payload);
  }
}
